<template>
  <div>
    <div v-if="!orders.list">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else>
      <div v-if="orders && orders.list && orders.list.length > 0">
        <h2>Zamówienia seniora dla siebie</h2>
        <pagination-inline
          :dispatchAction="`fetchAllCustomerOrders`"
          :onPage="this.orders ? this.orders.on_page : 20"
          :pageNumber="this.orders ? this.orders.page_number : 1"
          :total="this.orders.total"
          :filterParam="this.$route.params.id"
          :secondFilterParam="'for_myself'"
          :emitRefresh="refreshCounter"
        ></pagination-inline>
        <table class="table borderless table-striped">
          <thead>
            <tr class="tr-table">
              <th scope="col">ID zamówienia</th>
              <th scope="col">ID usługi</th>
              <th scope="col">Ponów zamówienie</th>
              <th scope="col">Wiadomości</th>
              <th scope="col">Usługa</th>
              <th scope="col">Wybrana opcja</th>
              <th scope="col">Data utworzenia</th>
              <th scope="col">Dni zamówienia</th>
              <th scope="col">Subskrypcja</th>
              <th scope="col">Dla kogo</th>
              <th scope="col">Imię</th>
              <th scope="col">Nazwisko</th>
              <th scope="col">PESEL</th>
              <th scope="col">Telefon</th>
              <th scope="col">Ulica</th>
              <th scope="col">Numer domu</th>
              <th scope="col">Numer mieszkania</th>
              <th scope="col">Piętro</th>
              <th scope="col">Kod pocztowy</th>
              <th scope="col">Miasto</th>
              <th scope="col">Data urodzenia</th>
              <th scope="col">Email</th>
              <th scope="col">Dodatkowa informacja do zamówienia</th>
              <th scope="col">Termin wykonania do</th>
              <!-- <th scope="col">Status zgłoszenia</th>
          <th scope="col">Status zgłoszenia (data i godz)</th> -->
              <th scope="col">Imie opiekuna</th>
              <th scope="col">Nazwisko opiekuna</th>
              <th scope="col">Telefon opiekuna</th>
              <th scope="col">Cena bazowa usługi</th>
              <th scope="col">Koszt po przeliczeniu</th>
              <th scope="col">Cena usługi ze zniżką</th>
              <th scope="col">Tryb</th>
              <th scope="col">Utworzone przez</th>
              <th scope="col">Status realizacji</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in orders.list" v-bind:key="item.id">
              <td>{{ item.id }}</td>
              <td>{{ item.userService.service.id }}</td>
              <td>
                <button
                  v-if="
                    !item.userService.service.serviceCategoryEntity
                      .is_special_type
                  "
                  type="button"
                  data-toggle="modal"
                  data-target="#repeatOrderModal"
                  class="btn btn-sm btn-outline-dark"
                  @click="prepareOrderToRepeat(item)"
                >
                  Ponów
                </button>
                <p v-else>Brak możliwości ponowienia zamówienia</p>
              </td>
              <td>
                <button
                  @click="getMessages(item.id, item.customerUser.id)"
                  type="button"
                  data-toggle="modal"
                  data-target="#messages"
                  class="btn btn-sm btn-outline-dark"
                >
                  Wiadomości
                </button>
              </td>

              <td>
                {{
                  item.userService.service.serviceCategoryEntity.display_name
                }}
              </td>
              <td>
                <button
                  @click="
                    setServiceDisplayNameToShow(
                      `${item.userService.service.display_name} ${
                        item.userService.service.description
                          ? item.userService.service.description
                          : ''
                      }`
                    )
                  "
                  type="button"
                  data-toggle="modal"
                  data-target="#service_name"
                  class="btn btn-sm btn-outline-dark mr-3 link"
                >
                  Pokaż
                </button>
              </td>
              <td>{{ formattedDate(item.creationDate) }}</td>
              <td>
                <button
                  v-if="item.order_days && item.order_days.length > 1"
                  type="button"
                  @click="openOrderDaysModal(item)"
                  class="btn btn-sm btn-outline-dark"
                >
                  Dni zamówienia
                </button>
                <p v-if="item.order_days && item.order_days.length === 1">
                  {{ formattedDateWithoutTime(item.order_days[0].date) }}
                </p>
                <p v-if="!item.order_days || item.order_days.length === 0">
                  Brak
                </p>
              </td>
              <td
                v-if="
                  item.user_subscriptions && item.user_subscriptions.length >= 1
                "
              >
                {{
                  dateWithoutTimeToString(
                    item.user_subscriptions[0].start_date_of_subscription
                  )
                }}
                -
                {{
                  dateWithoutTimeToString(
                    item.user_subscriptions[0].end_date_of_subscription
                  )
                }}
              </td>
              <td v-else>Brak</td>
              <td>
                {{
                  item.for_myself === true ? "Dla siebie" : "Dla kogoś innego"
                }}
              </td>
              <td>{{ item.customerProfile.first_name }}</td>
              <td>{{ item.customerProfile.last_name }}</td>
              <td>
                {{
                  item.userService.service.serviceCategoryEntity &&
                  item.userService.service.serviceCategoryEntity
                    .require_pesel_when_ordering
                    ? item.customer_pesel
                    : "Brak"
                }}
              </td>
              <td>{{ item.customerProfile.phone }}</td>
              <td>{{ item.customerProfile.street }}</td>
              <td>{{ item.customerProfile.number1 }}</td>
              <td>{{ item.customerProfile.number2 }}</td>
              <td>{{ item.customerProfile.floor }}</td>
              <td>{{ item.customerProfile.postcode }}</td>
              <td>{{ item.customerProfile.city }}</td>
              <td>
                {{ formattedDateWithoutTime(item.customerProfile.birthdate) }}
              </td>
              <td>{{ item.customerProfile.email }}</td>
              <td>{{ item.customerProfile.note }}</td>
              <td>{{ formattedDate(item.dateTo) }}</td>
              <td>{{ item.employee_profile.first_name }}</td>
              <td>{{ item.employee_profile.last_name }}</td>
              <td>{{ item.employeeUser.phone }}</td>
              <td>{{ item.basic_price }}</td>
              <td>{{ item.price }}</td>
              <td>
                {{
                  item.price_after_discount ? item.price_after_discount : "Brak"
                }}
              </td>
              <td>{{ item.time }}</td>
              <td>{{ item.created_by || "-" }}</td>
              <td>
                <div class="orderStatusWithRejectMessage">
                  <div>{{ item.orderState }}</div>
                  <div v-if="item.refusal_message">
                    <button
                      type="button"
                      data-toggle="modal"
                      :data-target="`#refusal${item.id}`"
                      class="btn btn-sm btn-outline-dark"
                    >
                      Powód
                    </button>
                  </div>
                </div>
              </td>
              <!-- Order days -->
              <order-days-modal
                :order="selectedOrderForOrderDays"
                @orderDayChanged="handleOrderDaysChanged"
              />

              <div
                class="modal fade"
                :id="`refusal${item.id}`"
                tabindex="-1"
                role="dialog"
                aria-labelledby="refusal"
                aria-hidden="true"
              >
                <div
                  class="modal-dialog modal-xl modal-dialog modal-xl-scrollable"
                  role="document"
                >
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">
                        Powód niezrealizowania usługi
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body messagesBody">
                      <h4>{{ item.refusal_comment }}</h4>
                      <h6>{{ item.refusal_message }}</h6>
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-outline-dark"
                        data-dismiss="modal"
                      >
                        Zamknij
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </tr>
          </tbody>
        </table>

        <!-- Repeat order modal -->
        <repeat-order-modal
          modalName="repeatOrderModal"
          :order="selectedOrderToRepeat"
          :userPromotionalCodes="userPromotionalCodes"
          @orderRepeated="handleOrderRepeated"
        />
      </div>
      <div v-else class="alert alert-danger notFoundListAlert">
        Ten użytkownik nie ma żadnych zamówień w swojej historii
      </div>

      <div
        class="modal fade"
        id="service_name"
        tabindex="-1"
        role="dialog"
        aria-labelledby="service_name"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-xl modal-dialog modal-xl-scrollable"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Wybrana opcja</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p v-html="displayNameToShow"></p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade messagesModal"
        id="messages"
        tabindex="-1"
        role="dialog"
        aria-labelledby="messages"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-xl modal-dialog modal-xl-scrollable"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Wiadomości z opiekunem
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div
              v-if="messages != null && messages.length > 0"
              class="modal-body messagesBody"
            >
              <div
                class="messages-wrapper"
                id="messages-container"
                ref="messages-container"
                v-show="messages != null && messages.length > 0"
              >
                <div
                  v-for="message in messages"
                  :key="message.id"
                  class="messageBlock"
                  :style="
                    message.user_id === seniorIdToMessages
                      ? 'border-bottom-left-radius: 0;  align-self: flex-start;'
                      : 'border-bottom-right-radius: 0;align-self: flex-end;'
                  "
                >
                  <div
                    class="messageInBlock"
                    :style="
                      message.type !== 'IMAGE'
                        ? message.user_id === seniorIdToMessages
                          ? 'background: #EC1A6B;border-bottom-left-radius: 0;justify-content: flex-start;'
                          : 'background:#090741;border-bottom-right-radius: 0;justify-content: flex-end;'
                        : message.user_id === seniorIdToMessages
                        ? 'background: white;border-bottom-left-radius: 0;justify-content: flex-start;'
                        : 'background:white;border-bottom-right-radius: 0;justify-content: flex-end;'
                    "
                  >
                    <!-- AVATARS -->
                    <div
                      v-if="
                        !message.from_first_name &&
                        seniorIdToMessages === message.user_id
                      "
                      class="messageAuthorUser"
                    >
                      <img
                        class="img-avatar"
                        :src="
                          getUrl() + `/api/profile/photo/${message.file_id}`
                        "
                        style="margin-right: 5px"
                      />
                    </div>
                    <div v-else class="messageAuthorAdmin">
                      <img
                        class="img-avatar"
                        :src="
                          getUrl() + `/api/profile/photo/${message.file_id}`
                        "
                        style="margin-right: 5px"
                      />
                    </div>

                    <!-- MESSAGE DATE -->
                    <div
                      class="messageBlockDateUser"
                      v-if="
                        !message.from_first_name &&
                        seniorIdToMessages === message.user_id
                      "
                    >
                      {{ formattedDateToString(message.creation_date) }}
                    </div>
                    <div v-else class="messageBlockDateAdmin">
                      {{ formattedDateToString(message.creation_date) }}
                    </div>
                    <span
                      v-if="
                        !message.from_first_name &&
                        seniorIdToMessages === message.user_id
                      "
                      class="userFirstName"
                      >Senior</span
                    >
                    <span v-else class="adminFirstName">Opiekun</span>
                    <span v-if="message.type === 'TEXT'">
                      {{ message.message }}
                    </span>
                    <span v-if="message.type === 'IMAGE'">
                      <a target="_blank" :href="message.message">
                        <img :src="message.message" class="imgInMessage" />
                      </a>
                    </span>
                    <span v-if="message.type === 'ATTACHMENT'">
                      <span
                        class="attachmentText"
                        @click="getFile(message.message, message.id)"
                        >Załącznik do pobrania</span
                      ><i
                        class="fas fa-download attachmentDownloadButton"
                        @click="getFile(message.message, message.id)"
                      ></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="modal-body messagesBody">
              <div class="alert alert-danger notFoundListAlert">
                Brak wiadomości
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { URL } from "../axios";
import axios from "../axios";
import shared from "../shared";
import PaginationInline from "../components/PaginationInline.vue";
import OrderDaysModal from "../components/OrderDaysModal.vue";
import RepeatOrderModal from "../components/RepeatOrderModal.vue";
export default {
  name: "SeniorOrders",
  components: { PaginationInline, OrderDaysModal, RepeatOrderModal },
  computed: {
    orders() {
      return this.$store.getters.getCustomerOrders;
    },
  },
  methods: {
    prepareOrderToRepeat(order) {
      this.selectedOrderToRepeat = order;
    },
    handleOrderRepeated() {
      this.$store.dispatch("fetchAllCustomerOrders", {
        filter_param: this.$route.params.id,
        second_filter_param: "for_myself",
      });
      axios
        .get(
          `/api/userPromotionalCode?promotional=true&active=true&userId=${this.$route.params.id}`
        )
        .then((response) => {
          this.userPromotionalCodes = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleOrderDaysChanged() {
      this.refreshCounter += 1;
    },
    openOrderDaysModal(order) {
      this.selectedOrderForOrderDays = order;
      const btnToOpen = window.document.getElementById("orderDaysModal-open");
      if (btnToOpen) btnToOpen.click();
    },
    setServiceDisplayNameToShow(displayName) {
      this.displayNameToShow = displayName;
    },
    getUrl() {
      return URL;
    },
    getMessages(id, seniorIdToMessages) {
      const url = `api/chat/messages/order/${id}`;
      this.seniorIdToMessages = seniorIdToMessages;
      axios
        .get(url)
        .then((response) => (this.messages = response.data.reverse()))
        .catch((error) => console.log(error));
    },
    async getUserData() {
      this.$store.dispatch("getUserById", {
        userId: this.$route.params.id,
      });
    },
  },
  created() {
    this.getUserData();
    this.$store.dispatch("fetchAllCustomerOrders", {
      filter_param: this.$route.params.id,
      second_filter_param: "for_myself",
    });
    this.formattedDate = shared.formattedDate;
    this.formattedDateWithoutTime = shared.formattedDateWithoutTime;
    this.formattedDateToString = shared.formattedDateToString;
    this.dateWithoutTimeToString = shared.dateWithoutTimeToString;
    axios
      .get(
        `/api/userPromotionalCode?promotional=true&active=true&userId=${this.$route.params.id}`
      )
      .then((response) => {
        this.userPromotionalCodes = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  data() {
    return {
      seniorIdToMessages: null,
      messages: null,
      displayNameToShow: "",
      refreshCounter: 1,
      selectedOrderForOrderDays: null,
      userPromotionalCodes: [],
      selectedOrderToRepeat: null,
    };
  },
};
</script>

<style scoped>
.messageDate {
  position: absolute;
  top: 3px;
  right: 3px;
}
.messagesBody {
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.messageBlock {
  position: relative;
  overflow-wrap: anywhere;
  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
  flex-direction: column;
  margin-left: 20px;
  flex-wrap: wrap;
  margin: 10px;
  border: 1px solid rgb(121, 118, 118);
  border-radius: 10px;
  width: 300px;
}
.messageBlock img {
  border-radius: 50px;
  width: 35px;
  height: 35px;
}
.messages-wrapper {
  overflow: scroll;
}
.form-group {
  width: 100%;
  margin: 40px auto;
}
.messages-wrapper {
  overflow-y: scroll;
  height: 500px;
  scrollbar-color: grey white;
  scrollbar-width: thin;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  margin: 0;
  padding: 0;
  width: 650px;
  justify-items: center;
  align-content: center;
}
.messageInBlock {
  display: flex;
  justify-content: center;
  width: auto;
  border-radius: 10px;
  position: relative;
  margin-left: 50px;
  margin-right: 50px;
  max-width: 350px;
  min-height: 50px;
  align-items: center;
  padding: 10px;
  min-width: 70px;
}
.messageAuthorUser img {
  border-radius: 50px;
  width: 45px !important;
  height: 45px !important;
}
.messageAuthorUser,
.messageAuthorAdmin {
  border-radius: 50px;
  width: 45px !important;
  height: 45px !important;
}
.messageBlock {
  font-family: "Poppins", sans-serif;
  position: relative;
  margin-top: 40px;
  border: 0;
  display: flex;
  position: relative;
  width: fit-content;
}
.messageAuthorUser {
  position: absolute;
  left: -55px;
  bottom: 5px;
}
.messageAuthorAdmin {
  position: absolute;
  right: -46px;
  bottom: -10px;
}
.messageBlockDateUser {
  position: absolute;
  bottom: -24px;
  left: -20px;
  color: rgb(126, 124, 124);
  min-width: 150px;
}
.messageBlockDateAdmin {
  position: absolute;
  bottom: -24px;
  right: -20px;
  color: rgb(126, 124, 124);
  min-width: 150px;
}

.message-image {
  max-height: 100px !important;
  width: 100px !important;
  height: 100px !important;
  margin-bottom: 5px;
}
.imageMessage {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.taskMessageAttachment {
  border-radius: 50px;
}
.adminFirstName {
  position: absolute;
  top: -17px;
  color: #090741;
  right: 10px;
}
.userFirstName {
  position: absolute;
  top: -17px;
  color: #090741;
}
.messageAuthorUser {
  width: 100px;
  height: 100px;
  border-radius: 5px;
}
.attachmentDownloadButton {
  cursor: pointer;
  margin-left: 5px;
}
.attachmentText {
  cursor: pointer;
}
.sendMessageForm {
  width: 100%;
  margin-top: 50px;
  position: relative;
  display: flex;
}
.sendMessageForm input {
}
#YourMessage {
  width: 95%;
  border-radius: 20px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: none;
  min-height: 150px;
  height: auto;
  background: #ebe6e6;
  outline: none;
  padding: 10px;
  padding-left: 10px;
  position: relative;
  text-align: center;
}
#file-input {
  visibility: hidden;
}
.messageInput {
  width: 100%;
  position: relative;
}
.selectFileInfo {
  position: absolute;
  right: 20px;
  bottom: -10px;
  font-size: 11px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
}
.selectFileInfo i {
  color: tomato;
  margin-left: 5px;
  cursor: pointer;
}
.selectFileInfo i:hover {
  color: red;
  margin-left: 5px;
}

/* SCROLL */
.messages-wrapper::-webkit-scrollbar {
  width: 8px;
}
.messages-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.messages-wrapper::-webkit-scrollbar-thumb {
  background: #888;
}
.messages-wrapper::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.charsCounter {
  position: absolute;
  bottom: 15px;
  right: 25px;
  font-size: 9px;
}
.labelAttachment {
  display: unset;
}
a:hover {
  text-decoration: none;
}
.imgInMessage {
  width: 100px;
}
</style>
